import React from "react";

import body from "./skillset.pug";

export const Skillset = ({ skillset }) => <>{body({ skillset })}</>;
